// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"FormContainer-moduleformContainer3Yv","titleStyle":"FormContainer-moduletitleStyle3r7"};